/**
 * Metric names as they appear in `strategy_column_sets.strategyweights`, mapped to
 * the `stocks_clean` field whose `<field>score` holds the 1-10 metric score.
 * Keys are normalized with `normalizeWeightLabel`.
 */
export const WEIGHT_LABEL_FIELDS: Record<string, string> = {
  "revenue, hist 3y, cagr": "RevGrowthhistCAGR3y",
  "revenue, fwd 1y growth": "RevenueGrowthFwd1Y",
  "revenue, fwd 3y, cagr": "Exp3YRevenueGrowthCAGR",
  "revenue, fwd 5y, cagr": "RevenueFwd5YCAGR",
  "eps growth year +1": "EPSGrowthFY1",
  "eps growth year +2": "EPSGrowthFY2",
  "eps growth year +3": "EPSGrowthFY3",
  "ebit margin": "EbitMargin",
  "net income margin": "NetIncomeMargin",
  "free cash flow margin": "FCFMargin",
  roe: "ROE",
  roa: "ROA",
  roce: "ROCE",
  "earnings stability index": "EatningsQualityScore",
  "net debt/ebitda": "NetDebtEBITDA",
  "p/e, fwd": "PEFWD",
  "p/e fy+3": "PE3Y",
  "ev/ebitda fwd": "EVEBITDAFWD",
  "ev/ebit fwd": "EVEBITFWD",
  "fcf yield": "FCFYield",
  "div yield": "DivdendYield",
  "p/bv": "PBV",
  "1 week return": "1weekreturn",
  "1 month return": "1monthreturn",
  "3 month return": "3monthreturn",
  "price% 52w high": "Priceof52WeekHigh",
  "1 year return": "1yearreturn",
  "3 year return": "3yearreturn",
  "5 year return": "5yearreturn",
  beta: "Beta",
  "st dev": "RealizedVolatility30dAnnualized",
};

export function normalizeWeightLabel(label: string): string {
  return label.toLowerCase().replace(/\s+/g, " ").trim();
}

export function weightLabelField(label: string): string | null {
  return WEIGHT_LABEL_FIELDS[normalizeWeightLabel(label)] ?? null;
}
